import { render, staticRenderFns } from "./AddNoteHandwriting.vue?vue&type=template&id=88592db4&scoped=true"
import script from "./AddNoteHandwriting.vue?vue&type=script&lang=js"
export * from "./AddNoteHandwriting.vue?vue&type=script&lang=js"
import style0 from "./AddNoteHandwriting.vue?vue&type=style&index=0&id=88592db4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88592db4",
  null
  
)

export default component.exports